export const POST_PRODUCT_SAVE = 'POST_PRODUCT_SAVE';
export const POST_PRODUCT_DELETE = 'POST_PRODUCT_DELETE';
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT_LIST_ACTIVE = 'GET_PRODUCT_LIST_ACTIVE';
export const GET_PRODUCT_RATE_PRODID = 'GET_PRODUCT_RATE_PRODID';
export const PRODUCT_ERROR = 'PRODUCT_ERROR';
